export default __webpack_public_path__ + "media/zurb/img/work/wtsbooks/wtsbooks-cover-34991f94abb1e54187935889371c21ee.png";